<template>
    <div>
        <v-slide-y-transition group :disabled="!transition">
            <div v-for="item in items.filter(x => localValue.some(y => y.id == x.id))" :key="item.id">
                <v-text-field
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation('required:' + (validation && (item.required || item.options?.required) ? 1 : 0))"
                    v-if="item.type === 'uuid'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                    class="arial-input"
                    readonly
                >
                    <template #append-inner>
                        <v-icon class="cursor-pointer me-2 position-relative z-index-9" color="primary" @click="localValue.find(x => x.id == item.id).value = null" v-if="localValue.find(x => x.id == item.id).value">clear</v-icon>
                        <v-icon @click="$text.copy(localValue.find(x => x.id == item.id).value)" class="cursor-pointer me-2" color="primary" size="21" v-if="localValue.find(x => x.id == item.id).value">content_copy</v-icon>
                        <v-icon class="cursor-pointer position-relative mx-1 z-index-9" color="primary" @click="localValue.find(x => x.id == item.id).value = uuid()">refresh</v-icon>
                    </template>
                </v-text-field>
                <v-text-field
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation(['required:' + (validation && (item.required || item.options?.required) ? 1 : 0), item.options?.min_length ? 'minLength:' + item.options?.min_length : false, item.options?.max_length ? 'maxLength:' + item.options?.max_length : false].filter(Boolean))"
                    v-if="item.type === 'text'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                ></v-text-field>
                <v-text-field
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation(['required:' + (validation && (item.required || item.options?.required) ? 1 : 0)].filter(Boolean))"
                    :type="passes.find(x => x.id == item.id)?.value ? 'text' : 'password'"
                    :append-inner-icon="localValue.find(x => x.id == item.id).value ? passes.find(x => x.id == item.id)?.value ? 'visibility_off' : 'visibility' : ''"
                    @click:appendInner="() => {
                        if (!passes.find(x => x.id == item.id))
                            passes.push({id: item.id, value: true});
                        else
                            passes.find(x => x.id == item.id).value = !passes.find(x => x.id == item.id).value;
                    }"
                    autocomplete="off"
                    v-if="item.type === 'password'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                ></v-text-field>
                <v-text-field
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation(['required:' + (validation && (item.required || item.options?.required) ? 1 : 0), 'url'].filter(Boolean))"
                    v-if="item.type === 'url'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                ></v-text-field>
                <v-textarea
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation(['required:' + (validation && (item.required || item.options?.required) ? 1 : 0), item.options?.min_length ? 'minLength:' + item.options?.min_length : false, item.options?.max_length ? 'maxLength:' + item.options?.max_length : false].filter(Boolean))"
                    no-resize
                    rows="3"
                    v-else-if="item.type === 'textArea'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                ></v-textarea>
                <v-select
                    :items="item.options?.items.split('\n').map((x) => { return {name: x.split(':').at(0), id: x.split(':').at(-1)}})"
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation('required:' + (validation && (item.required || item.options?.required) ? 1 : 0))"
                    item-title="name"
                    item-value="id"
                    no-data-text="موردی پیدا نشد!"
                    v-else-if="item.type === 'dropdown'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                    :value-comparator="(a, b) => a == b"
                ></v-select>
                <v-checkbox
                    :label="item.label"
                    class="mt-0 pt-0"
                    v-else-if="item.type === 'checkbox'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                    true-value="1"
                    false-value="0"
                    :value-comparator="(a, b) => a == b"
                ></v-checkbox>
                <v-text-field
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation(['required:' + (validation && (item.required || item.options?.required) ? 1 : 0), item.options?.min ? 'min:' + item.options?.min : false, item.options?.max ? 'max:' + item.options?.max : false].filter(Boolean))"
                    v-else-if="item.type === 'number'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                ></v-text-field>
                <datetime-input
                    :label="(validation && (item.required || item.options?.required) ? '* ' : '') + item.label"
                    :rules="$validation('required:' + (validation && (item.required || item.options?.required) ? 1 : 0))"
                    :type="item.options?.type"
                    v-else-if="item.type === 'date'"
                    v-model="localValue.find(x => x.id == item.id).value"
                    :disabled="disabled"
                ></datetime-input>
            </div>
        </v-slide-y-transition>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
    data() {
        return {
            values: [],
            passes: [],
        };
    },
    props: {
        modelValue: {
            required: true,
            default: null
        },
        transition: {
            type: Boolean,
            default: false,
        },
        validation: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        localValue: {
            get: function () { return this.modelValue },
            set: function (value) { this.$emit('update:modelValue', value)},
        },
    },
    watch: {
        items() {
            this.localValue = this.items.map(x => Object.assign({}, {id: x.id, value: this.localValue?.find(y => y.id == x.id)?.value ?? (x.type == 'checkbox' ? false : null)}));
        },
    },
    methods: {
        uuid() {
          return uuidv4().toUpperCase();
        },
    },
};
</script>
